import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

import { computed, ref } from 'vue'
import { NewProfileRelationship, isChildRelationship } from './ProfileManager'
import { Modal as BsModal } from 'bootstrap'
import ProfileCreatorSelector from './ProfileCreatorSelector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileAddRelatedModal',
  emits: [
  'added',
],
  setup(__props, { expose: __expose, emit }) {



const relationshipRef = ref(NewProfileRelationship.Son)
const relatedItemIdRef = ref<string>()
const useExistingRef = ref(true)
const busyRef = ref(false)
const modalRef = ref<HTMLElement>()
const creatorSelectorRef = ref<InstanceType<typeof ProfileCreatorSelector>>()

const titleRef = computed(() => isChildRelationship(relationshipRef.value) ? 'Add child' : 
  relationshipRef.value == NewProfileRelationship.Husband ? 'Add husband' : 'Add wife')
const chooseGenderRef = computed(() => isChildRelationship(relationshipRef.value))
const addButtonTextRef = computed(() => busyRef.value ? 'Adding...' :
  useExistingRef.value ? 'Add relationship' : titleRef.value)
const canAddRef = computed(() => !busyRef.value && creatorSelectorRef.value?.isValid)

__expose({
  open,
})

function open(rel: NewProfileRelationship, relatedItemId: string) {
  relationshipRef.value = rel
  relatedItemIdRef.value = relatedItemId
  creatorSelectorRef.value?.reset()

  BsModal.getOrCreateInstance(modalRef.value!).show()
}

function close() {
  BsModal.getOrCreateInstance(modalRef.value!).hide()
}

async function addRelationship() {
  if (!creatorSelectorRef.value)
    throw 'No creator selector'

  busyRef.value = true

  const profilePersonId = await creatorSelectorRef.value.getOrCreateProfileAsync()
  await creatorSelectorRef.value.getOrCreateRelationshipAsync(profilePersonId)

  close()
  emit('added')

  busyRef.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalRef",
    ref: modalRef,
    class: "modal add-related-profile-modal",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(titleRef.value), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ProfileCreatorSelector, {
            ref_key: "creatorSelectorRef",
            ref: creatorSelectorRef,
            "choose-gender": chooseGenderRef.value,
            relationship: relationshipRef.value,
            "related-item-id": relatedItemIdRef.value,
            "use-existing": useExistingRef.value,
            "onUpdate:useExisting": _cache[0] || (_cache[0] = ($event: any) => ((useExistingRef).value = $event)),
            disabled: busyRef.value
          }, null, 8, ["choose-gender", "relationship", "related-item-id", "use-existing", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            disabled: !canAddRef.value,
            onClick: addRelationship
          }, _toDisplayString(addButtonTextRef.value), 9, _hoisted_8),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal"
          }, " Cancel ", 8, _hoisted_9)
        ])
      ])
    ])
  ], 512))
}
}

})